import React,{useState, useEffect} from 'react';
import style from './assessmentNotes.module.scss';
import { Button, Form, TextArea } from '../../primary';
import { useForm } from 'react-hook-form';
import { useParams } from 'react-router';
import { CANCEL_BTN, SAVE_BTN } from '../../../constants';
import { fullMonthFormatDate, signedLockedAccess } from '../../../utils';
import {allowEnterData} from '../../../utils/patientsHelper';
import Loader from '../../../static/images/spinner.svg';
import { ZoomPhoto } from './Photos';
import { useSelector } from 'react-redux';
export const AssessmentNotes = ({ notes, postNotes, detailAssessment, hideIt }) => {
  const { patientId } = useParams();
  const { assessmentId } = useParams();
  const { register, handleSubmit, reset } = useForm();
  const { measurementData } = useSelector((state) => state.patient.newWoundMeasurements) || { loading: false, measurementData: null };

  const [woundImageLoading, setWoundImageLoading] = useState(true);

  const clearField = () => {
    reset();
  }
  const doSubmit = (data) => {
    if (data?.notes.trim() !== '') {
      const payload = {
        "assessmentId": assessmentId,
        "patientId": patientId,
        "notes": data.notes.trim()
      }
      postNotes(payload);
    }
    reset();
  }
  const allowEnter = (e) => {
    allowEnterData(e)
    // if (e.key === 'Enter') {
    //   e.stopPropagation();
    // }
  }

const [tinyDelay, setTinyDelay] = useState(false)

useEffect(() => {
  setTimeout(() => {
    setTinyDelay(true)
  }, 2500)
}, [])
  
  return <div>
{!tinyDelay ?<div className={`${'loader'} col-12`}>
				<img src={Loader} alt="loading" />
			  </div>:
        <>
    <div className="row d-flex d-flex row no-gutters">

      <div className={`col-4`} style={{overflow : 'hidden'}}>
        <div  className={`${style.patient_wound}`}>
          <ZoomPhoto
              image={measurementData?.assessedImageSASURL || measurementData?.intialImageSASURL || detailAssessment?.picture}
              loading={woundImageLoading}
              setLoading={setWoundImageLoading}
              showBottomBtn={false}
              classes={{
                outerClass: undefined,
                innerClass: "position-relative w-100",
                shimmerClass: style.image_skleton
              }}
              showTopBtn={detailAssessment?.isWoundWithoutPhoto === 0}
          />
        </div>
      </div>

      <div className={`col-8 w-100`}>
        <div className={`${style.notes_conatiner} w-100`}>
          {hideIt && signedLockedAccess(detailAssessment?.assessmentStage)? <div>
            <div className="pt-2 pb-2"><span className={style.notes_title}>Notes:</span> <span className={style.notes_sub_title}>(Optional)</span></div>
            <Form  onSubmit={handleSubmit(doSubmit)}>
              <div>
                <TextArea
                  classes={{ inputClassName: `${style.textarea_box} w-100 mb-2` }}
                  rows={3}
                  id={"notesField"}
                  name={"notes"}
                  placeholder={'Add notes here'}
                  validator={register}
                  onKeyPress={(e) => allowEnter(e)}
                />
              </div>
              <div className="d-flex justify-content-end w-100">
                <Button
                  type={"submit"}
                  value={SAVE_BTN}
                  id={"updateNotes"}
                  classes={{ className: `btn p-1 ${style.btn_primary}` }}
                />
                <Button
                  type={"button"}
                  value={'Clear'}
                  id={"updateCancel"}
                  classes={{ className: `btn p-1 ${style.btn_scondary}` }}
                  onClick={() => clearField()}
                />
              </div>
            </Form>
          </div>:'This wound assessment is signed and locked, cannot be updated.'}
          {notes&&Array.isArray(notes)&&notes?.length !== 0 && <div className={style.notes_container}>
            {notes&&Array.isArray(notes) && notes.map((data, index) => {
              return <div className={style.entered_notes} key={index}>
                  <div className={style.post_details}>
                    <span className={style.creater_name}>{data.createdBy}</span> | <span>{fullMonthFormatDate(data.createdDate)}</span> | <span>{data.createdByRole}</span>
                  </div>
                  <div className={style.notes_text}>{data?.notes === '' ? 'Unknown' : data?.notes?.split('\n').map(str => <div>{str}</div>)}</div>
                </div> 
            })}
          </div>}
        </div>
      </div>

    </div></>}
  </div>
}
